//Vtiger Blog Template Form JS Code
document.addEventListener('DOMContentLoaded', function () {

  function normalizeMobile(value) {
    return (value || '').replace(/\D/g, '').slice(-10);
  }

  document.querySelectorAll('.sv-vtiger form').forEach(function(form) {
    if (form.dataset.ajaxReady === '1') return;
    form.dataset.ajaxReady = '1';

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var mobile = form.querySelector('input[name="mobile"]');

      if (mobile) {
        var value = normalizeMobile(mobile.value);
        mobile.value = value;

        if (!/^[0-9]{10}$/.test(value)) {
          alert('Please enter a valid 10 digit mobile number.');
          mobile.focus();
          return false;
        }
      }

      var submitBtn = form.querySelector('button[type="submit"]');
      var oldBtnText = submitBtn ? submitBtn.innerHTML : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Submitting...';
      }

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        mode: 'no-cors'
      })
      .then(function() {
        form.innerHTML = `
          <div class="sv-success-message">
            Thank you! Your request has been submitted successfully.
          </div>
        `;
      })
      .catch(function() {
        alert('Something went wrong. Please try again.');

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = oldBtnText;
        }
      });
    });
  });

});

//Vtiger Form JS Code Close

document.addEventListener('DOMContentLoaded', function () {
  const description = document.querySelector('.js-collection-description');
  const button = document.querySelector('.collection-read-more');

  if (!description || !button) return;

  const paragraphs = description.querySelectorAll('p');

  // 🔥 IMPORTANT RULE:
  // Collapse ONLY if content is actually long
  if (paragraphs.length < 1) {
    button.style.display = 'none';
    return;
  }

  const firstParagraph = paragraphs[0];

  const extraWrapper = document.createElement('div');
  extraWrapper.className = 'collection-extra-content';

  let node = firstParagraph.nextSibling;
  while (node) {
    const current = node;
    node = node.nextSibling;
    extraWrapper.appendChild(current);
  }

  firstParagraph.after(extraWrapper);

  button.addEventListener('click', function () {
    const expanded = description.classList.toggle('is-expanded');
    button.textContent = expanded ? 'Read Less' : 'Read More';
  });
});


// Product Tags url redirections JS

document.addEventListener("DOMContentLoaded", function () {
  if (
    window.location.pathname.startsWith("/collections/yarn-dyed-fabrics/") &&
    window.location.pathname !== "/collections/yarn-dyed-fabrics/"
  ) {
    window.location.replace("/collections/yarn-dyed-fabrics/");
  }
});

document.addEventListener("DOMContentLoaded", function () {

  const redirects = {
    "/collections/all/fabric-swatch-book": "/collections/natural-dyeing-kit",
    "/collections/all/bamboo-fabric": "/collections/bamboo-fabrics",
    "/collections/all/hemp-fabric-in-india": "/collections/hemp-fabric",
    "/collections/all/white-fabric": "/collections/organic-fabrics",
    "/collections/all/natural-dyes-ingredient": "/collections/natural-dyeing-kit",
    "/collections/all/dyeing-ingredients": "/collections/natural-dyeing-kit",
    "/collections/all/bandana": "/collections/utility-products/bandana",
    "/collections/all/hemp-fabric": "/collections/hemp-fabric",
    "/collections/all/powder": "/collections/natural-dyeing-kit",
    "/collections/all/organic-woven-fabric": "/collections/wool-fabrics",
    "/collections/all/dyed-and-printed-fabric": "/collections/dyes-and-printed-fabrics"
  };

  let currentPath = window.location.pathname;

  if (redirects[currentPath]) {
    window.location.replace(redirects[currentPath]);
  }

});

// Pagination Code JS

if (window.location.href.includes("/collections/all/hemp-fabric-in-india?page=2")) {
  window.location.replace("/collections/hemp-fabric");
}

if (window.location.href.includes("/collections/all/dyed-and-printed-fabric?page=2")) {
  window.location.replace("/collections/dyes-and-printed-fabrics");
}